export default {
  'infobits.type.infobit': {
    name: 'Infobit',
    icon: 'info-circle',
    titleLabel: 'Infobit Title',
    css: {
      color: '#107090'    /* matches --hotspot-color (infobits-app.vue) */
    },
    detailDefs: [
      {
        prop: 'text',
        label: 'Notes',
        dataType: 'HTML'
      }
    ]
  },
  'infobits.type.person': {
    name: 'Person',
    icon: 'user',
    titleLabel: 'Person Name',
    css: {
      color: '#107090'    /* matches --hotspot-color (infobits-app.vue) */
    },
    detailDefs: [
      {
        prop: 'birthDate',
        label: 'Year of birth',
        dataType: 'Number'
      },
      {
        prop: 'birthPlace',
        label: 'Place of birth',
        dataType: 'Text'
      },
      {
        prop: 'text',
        label: 'Notes',
        dataType: 'HTML'
      }
    ]
  },
  'infobits.type.question': {
    name: 'Question',
    icon: 'question-circle',
    titleLabel: 'Question',
    css: {
      color: '#c04010'
    },
    detailDefs: [
      {
        prop: 'text',
        label: 'Notes',
        dataType: 'HTML'
      }
    ]
  },
  'infobits.type.structural_element': {
    name: 'Structural Element',
    icon: 'asterisk',
    titleLabel: 'Structural Element',
    css: {
      color: 'grey'
    },
    detailDefs: [
      {
        prop: 'text',
        label: 'Notes',
        dataType: 'HTML'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/infobit-typedefs.js